export default "__VITE_ASSET__CKcxMI$6__"